import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "@/lib/auth";

export interface AuthUser {
  name: string;
  email: string;
}

export function useAuth() {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const user: AuthUser | null =
    accounts.length > 0
      ? {
          name: accounts[0]?.name ?? "Unknown",
          email:
            accounts[0]?.username ?? accounts[0]?.idTokenClaims?.email as string ?? "",
        }
      : null;

  const login = async () => {
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  const logout = () => {
    // Clear local MSAL cache only — don't redirect to Microsoft's logout endpoint
    const account = instance.getActiveAccount() ?? accounts[0];
    if (account) {
      instance.setActiveAccount(null);
      instance.clearCache();
    }
    window.location.assign(window.location.origin);
  };

  return {
    user,
    isAuthenticated,
    isLoading: inProgress !== InteractionStatus.None,
    login,
    logout,
  };
}
